import { useEffect } from "react";
import "./ConfirmCreateIdModal.css";

const ConfirmCreateIdModal = ({ open, onClose, onProceed }) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="rr-confirm-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="rr-confirm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="rr-confirm-create-id-title"
        aria-describedby="rr-confirm-create-id-desc"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="rr-confirm-modal__icon-wrap" aria-hidden="true">
          <span className="material-symbols-rounded rr-confirm-modal__icon">
            warning
          </span>
        </div>

        <h2
          id="rr-confirm-create-id-title"
          className="rr-confirm-modal__title"
        >
          All set to go?
        </h2>

        <p
          id="rr-confirm-create-id-desc"
          className="rr-confirm-modal__desc"
        >
          You&apos;re about to create the employee ID for this candidate.
          Double-check that every section looks right — once you confirm, the
          ID is generated and there&apos;s no pulling it back.
        </p>

        <div className="rr-confirm-modal__actions">
          <button
            type="button"
            className="btn p-btn p-btn-blk rr-confirm-modal__btn"
            onClick={onClose}
          >
            <div className="p-btn-text">Let me recheck</div>
          </button>
          <button
            type="button"
            className="btn p-btn p-btn-og rr-confirm-modal__btn"
            onClick={onProceed}
          >
            <div className="p-btn-text">Yes, create ID</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCreateIdModal;
